import store from '@/store'

/**
 * 确认登录
 * @returns {Promise}
 */
export const confirmLogin = async () => {
  if (hcApp.isHCApp()) {
    const userInfo = await hcApp.postMessage({ methodName: 'confirmLogin' })
    if (userInfo.acpToken) {
      await store.dispatch('getUserInfo')
      return userInfo
    } else {
      throw new Error('用户未登录')
    }
  } else {
    return {}
  }
}
/**
 * 金钱单位置换  2999 --> 2,999.00
 * @param val
 * @param unit
 * @returns {*}
 */
export function unitPrice(price, toFix = false) {
  let _price
  const regExp = /\B(?=(\d{3})+(?!\d))/g
  try {
    _price = Number(price)
    if (Number.isNaN(_price)) {
      return 0
    }
    if (!Number.isInteger(_price)) {
      _price = _price.toFixed(2)
    }
    if (toFix) {
      return String(Number(_price).toFixed(2)).replace(regExp, ',')
    } else {
      return String(Number(_price)).replace(regExp, ',')
    }
  } catch (error) {
    console.log(error)
    return price || 0
  }
}

/**
 * 浏览数量格式化：最多显示4位，超过9999，以万未单位，显示 1W，1.1W等，最多显示1位小数点，四舍五入；
 * @param count
 * @returns {string}
 */
export function viewCountFormat(count) {
  count = Number(count)
  if (Number.isNaN(count)) {
    return '0'
  } else if (count > 9999) {
    const _count = (count / 10000).toFixed(1)
    return `${_count}W`
  } else {
    return count
  }
}

/**
 * 点赞数量格式化：最多显示3位，超过999，显示999+；
 * @param count
 * @returns {string}
 */
export function fabulousCountFormat(count) {
  count = Number(count)
  if (Number.isNaN(count)) {
    return '0'
  } else if (count > 999) {
    return '999+'
  } else {
    return count
  }
}

/**
 * 点赞数量格式化：最多显示3位，超过999，显示999+；
 * @param count
 * @returns {string}
 */
export function newFabulousCountFormat(count) {
  count = Number(count)
  if (Number.isNaN(count)) {
    return '0'
  } else if (count < 10000) {
    return count
  } else if (count >= 10000 && count < 10000000) {
    count = (count / 10000).toFixed(1)
    return count + 'w'
  } else if (count >= 10000000) {
    return '999w+'
  }
}
// 年月日时分秒
export function formatTime(time) {
  try {
    const date = new Date(time)
    if (isNaN(date.getTime())) return ''
    const month = date.getMonth() + 1 < 10 ? `0${date.getMonth() + 1}` : date.getMonth() + 1
    const day = date.getDate() < 10 ? `0${date.getDate()}` : date.getDate()
    const hour = date.getHours() < 10 ? `0${date.getHours()}` : date.getHours()
    const minute = date.getMinutes() < 10 ? `0${date.getMinutes()}` : date.getMinutes()
    const second = date.getSeconds() < 10 ? `0${date.getSeconds()}` : date.getSeconds()
    return `${date.getFullYear()}-${month}-${day} ${hour}:${minute}:${second}`
  } catch (error) {
    return ''
  }
}

// 年月日
export function formatDate(time) {
  try {
    const date = new Date(time)
    if (isNaN(date.getTime())) return ''
    const month = date.getMonth() + 1 < 10 ? `0${date.getMonth() + 1}` : date.getMonth() + 1
    const day = date.getDate() < 10 ? `0${date.getDate()}` : date.getDate()
    const hour = date.getHours() < 10 ? `0${date.getHours()}` : date.getHours()
    const minute = date.getMinutes() < 10 ? `0${date.getMinutes()}` : date.getMinutes()
    const second = date.getSeconds() < 10 ? `0${date.getSeconds()}` : date.getSeconds()
    return `${date.getFullYear()}-${month}-${day}`
  } catch (error) {
    return ''
  }
}

/**
 * 限流函数
 * @param {需要包装的函数} fn
 * @param {时间差} time
 * @returns
 */
export function throttle(fn, interval) {
  // 维护上次执行的时间
  let last = 0
  return function () {
    const context = this
    const args = arguments
    const now = Date.now()
    // 根据当前时间和上次执行时间的差值判断是否频繁
    if (now - last >= interval) {
      last = now
      fn.apply(context, args)
    }
  }
}

/**
 * 防抖函数
 * @param {需要包装的函数} fn
 * @param {时间差} time
 * @param {是否要立即执行一次} immediate
 * @returns
 */
export const debounce = function (fn, time, immediate = true) {
  var timer // 定义一个定时器
  if (immediate) {
    return function () {
      clearTimeout(timer) // 直接清除之前的定时器
      var self = this // 保存this的值
      var args = arguments // 利用闭包保存参数数组
      var callNow = !timer // 取反
      timer = setTimeout(function () {
        timer = null // 清空定时器
      }, time)
      if (callNow) {
        fn.apply(self, args) // 调用apply进行参数的传入
      }
    }
  } else {
    return function () {
      clearTimeout(timer) // 直接清除之前的定时器
      var self = this // 保存this的值
      var args = arguments // 利用闭包保存参数数组
      timer = setTimeout(function () {
        fn.apply(self, args) // 调用apply进行参数的传入
      }, time)
    }
  }
}

/**
 * 判断是否为小程序环境
 * @returns boolea
 */
export function isMiniProgramNew() {
  return navigator.userAgent.indexOf('miniProgram') > -1
}

/**
 * 判断是否为微信浏览器环境（不含小程序）
 * @returns boolea
 */
export function isWeiXinButNotMini() {
  return navigator.userAgent.toLowerCase().indexOf('micromessenger') > -1 && !isMiniProgramNew()
}
